import classnames from 'classnames'
import type { PropsWithChildren, FC } from 'react'
import React from 'react'

import styles from './GridCell.module.css'

type Props = {
  secondary?: boolean
  borderLeft?: boolean
  darkBorder?: boolean
  stickyLeft?: boolean
  alternateBorder?: boolean
  size?: 'full' | 'half'
  className?: string
}

export const GridCell: FC<PropsWithChildren<Props>> = ({
  children,
  secondary,
  darkBorder,
  borderLeft,
  stickyLeft,
  alternateBorder,
  className = '',
  size = 'full'
}) => {
  return (
    <div
      className={classnames(
        styles.GridCell,
        {
          [styles.FullWidth]: size === 'full',
          [styles.HalfWidth]: size === 'half',
          [styles.BorderLeft]: borderLeft,
          [styles.DarkBorderLeft]: darkBorder,
          [styles.StickyLeft]: stickyLeft,
          [styles.Secondary]: secondary,
          [styles.HalfAlternateBorders]: alternateBorder
        },
        className
      )}
    >
      {children}
    </div>
  )
}

type HalfGridProps = Omit<Props, 'size'> & {
  alternateBorder?: boolean
}

export const HalfGridCell: FC<PropsWithChildren<HalfGridProps>> = React.memo(
  ({ children, className, alternateBorder, ...other }) => {
    return (
      <GridCell
        className={classnames(className, {
          [styles.HalfAlternateBorders]: alternateBorder
        })}
        size='half'
        {...other}
      >
        {children}
      </GridCell>
    )
  }
)
